import axios from "axios";
import { useMsal } from "@azure/msal-react";
import {
  InteractionRequiredAuthError,
  PublicClientApplication,
} from "@azure/msal-browser";
import { useNavigate } from "react-router-dom";
import { msalConfig } from "../authConfig";

const BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://cilhouatapi.castroldms.com/api";
export const CDRRedirectionBaseURL = process.env.REACT_APP_CDR_REDIRECT_URL || "https://cilcdroat.castroldms.com/InnoRiseAdminLoginSSO.aspx?";
const msalInstance = new PublicClientApplication(msalConfig);
const getToken = () => {
  return localStorage.getItem("userToken");
};
const Axios = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
});
export default Axios;

export const AxiosWOToken = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
});

export const AxiosExcel = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "multipart/form-data" },
});
Axios.interceptors.request.use(
  async (config) => {
    // debugger
    // Get the access token from MSAL
    const token: any = getToken();
    // console.log(JSON.parse(token).secret,"user");
    // If token is available, add it to the Authorization header
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    // else{
    //   const navigate = useNavigate(); // Get the navigate function to redirect
    //   navigate("/"); // Redirect to the login page
    // }

    return config;
  },
  (error) => {
    const navigate = useNavigate(); // Get the navigate function to redirect
    navigate("/"); // Redirect to the login page
    return Promise.reject(error);
  },
);

// You can also add response interceptors if you want to handle errors globally
Axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const originalRequest = error.config;
    // Handle common errors, like unauthorized
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;
      const token = getToken();
      if (token) {
        originalRequest.headers.Authorization = `Bearer${token}`;
        return Axios(originalRequest);
      } else {
        // You can redirect to the login page or show a login modal here
        window.location.href = "/";
        console.error("Unauthorized. Please log in.");
      }
    }
    return Promise.reject(error);
  },
);
AxiosExcel.interceptors.request.use(
  async (config) => {
    // debugger
    // Get the access token from MSAL
    const token: any = getToken();
    // console.log(JSON.parse(token).secret,"user");
    // If token is available, add it to the Authorization header
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    // else{
    //   const navigate = useNavigate(); // Get the navigate function to redirect
    //   navigate("/"); // Redirect to the login page
    // }

    return config;
  },
  (error) => {
    const navigate = useNavigate(); // Get the navigate function to redirect
    navigate("/"); // Redirect to the login page
    return Promise.reject(error);
  },
);

// You can also add response interceptors if you want to handle errors globally
AxiosExcel.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const originalRequest = error.config;
    // Handle common errors, like unauthorized
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;
      const token = getToken();
      if (token) {
        originalRequest.headers.Authorization = `Bearer${token}`;
        return Axios(originalRequest);
      } else {
        // You can redirect to the login page or show a login modal here
        window.location.href = "/";
        console.error("Unauthorized. Please log in.");
      }
    }
    return Promise.reject(error);
  },
);
